import React from "react";
import SearchIcon from "../../assets/images/SearchIcon";
import { useTranslation } from "react-i18next";

const SearchBar = ({ from }: { from: "Header" | "Staff" }) => {
  const { t } = useTranslation();

  const baseClass =
    "w-full px-4 ps-10 text-sideMenuHelpBox staffListDownloadCheckbox border border-StaffListDownloadCheckboxBorderColor rounded-lg bg-whiteColor";

  const classNameHeader = `${baseClass} h-[48px]`;
  const classNameStaff = `${baseClass} h-[44px] cursor-not-allowed`;

  return (
    <div className="relative w-full hidden md:block lg:block">
      <div className="absolute inset-y-0 start-0 flex items-center ps-3">
        <SearchIcon />
      </div>
      <input
        type="search"
        className={from === "Header" ? classNameHeader : classNameStaff}
        placeholder={from === "Header" ? t("SearchForAnything") : t("Search")}
        disabled={true}
      />
    </div>
  );
};

export default SearchBar;
